import * as z from "zod";

export const ConciergeContextSettingsParser = z.object({
  productMetafieldKeys: z.array(z.string()),
});

export type ConciergeContextSettings = z.infer<
  typeof ConciergeContextSettingsParser
>;
